
/**
 * @export
 * @enum {string}
 */
export enum ReferenceEntityType {
    COMPANY_TYPE = 'COMPANY_TYPE',
    PERSON_TYPE = 'PERSON_TYPE'
}